import api from "../_api";

const index = async ({ commit }, query) => {
  const result = await api.index(query);
  commit("STORE_PROCESSES", result);
};

const getPendingProcesses = async ({ commit }, query) => {
  const result = await api.pendingProcesses(query);
  commit("STORE_PENDING_PROCESSES", result);
};

const getProcessTypes = async ({ commit }, query) => {
  const result = await api.processTypes(query);
  commit("STORE_PROCESS_TYPES", result);
};

const getProcessStatus = async ({ commit }, query) => {
  const result = await api.processStatus(query);
  commit("STORE_PROCESS_STATUS", result);
};

const getDepartaments = async ({ commit }, query) => {
  const result = await api.processDepartaments(query);
  commit("STORE_PROCESS_DEPARTAMENTS", result);
};

export default {
  index,
  getProcessTypes,
  getProcessStatus,
  getDepartaments,
  getPendingProcesses
};
